exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-4-wrapper[data-v-31dbeeb2]{width:235px;padding-bottom:10px}.top-border[data-v-31dbeeb2]{width:calc(100% + 3px);height:100px;margin-bottom:5px;margin-left:-1px}.top-rating-box[data-v-31dbeeb2]{width:100px;height:100px;background:#fff;border-radius:50%;margin:auto;margin-top:-55px;text-align:center}.top-average-rating[data-v-31dbeeb2]{font-size:24px;font-weight:700;padding-top:10px}.listing-img[data-v-31dbeeb2]{width:50px;height:50px;border-radius:50%;display:inline-block}", ""]);

// exports
